export default __webpack_public_path__ + "static/1.2-Text-alternatives-DONT-40408c7bd5458234adc35b0073b1f9b4.png";